<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {doShow as showAlert} from '../../#common/alert/store'
    import {findByUserName} from 'src/components/cabinet/#services/tasksBot'

    let userName
    let loading = false

    async function searchUser() {
        try {
            loading = true

            let user = await findByUserName.request({data:{ userName: userName.toLowerCase() }})

            if (user?.clientId) {
                userName = ''
                location.href = '/tasks/profile/' + user.clientId
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'User not found'
                })
            }
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
        }
    }
</script>

<svelte:head>
    <title>Search</title>
</svelte:head>

<MainLayout title="Search">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="tasks" class="btn btn-primary mb-3">Back</Link>
                <form class="panel" on:submit|preventDefault={searchUser} novalidate>
                    <label>Find user by @username</label>
                    <div class="input-group mb-3 filter">
                        <span class="input-group-text">@</span>
                        <input type="text" class="form-control" bind:value={userName} placeholder="Enter username" autofocus>
                        <button type="submit" class="btn btn-primary" class:loading={loading} disabled={loading || userName === ''}>Search</button>
                    </div>
                </form>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .filter {
        max-width: 350px;
    }
</style>
